export default {
  title: 'Geniet van de beste ervaring in onze mobiele app',
  description: 'Bespaar tijd, verdien beloningen, ontvang meldingen over meer aanbiedingen en meer',
  buttons: {
    download: 'Open de {{name}}-app',
  },
};
